import axios from "axios";
import * as actionType from "../../../constant/actionType";

const GenerateWorkerOverviewReportFunction = (apiData) => async (dispatch) => {
 try {
  console.log("Working ??")
  const response = await axios({
   method: "post",
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/GenerateWorkerOverviewReportFunction`,
   data: {
    ...apiData,
    provider_org_ids: JSON.stringify(
      apiData.provider_org_ids?.map((item) => item?.provider_org_id)
    ),
    client_org_ids: JSON.stringify(apiData?.client_org_ids),
    worker_ids: JSON.stringify(apiData?.worker_ids),
    individual_ids: JSON.stringify(apiData?.individual_ids),
   },
  });

  return response.data;
 } catch (error) {
  console.error("GenerateWorkerOverviewReportFunction failed", error);
  throw error.response?.data || error;
 }
};

export { GenerateWorkerOverviewReportFunction };

